import { SECURITY_EVENTS, EVENT_SEVERITY } from './constants';

export function subscribeBeforeUnload(examActive, policy) {
  if (typeof window === 'undefined' || !policy.blockNavigationAway) return () => {};
  const handler = (event) => {
    if (!examActive()) return;
    event.preventDefault();
    event.returnValue = '';
  };
  window.addEventListener('beforeunload', handler);
  return () => window.removeEventListener('beforeunload', handler);
}

export function subscribePopState(logSecurityEvent, examActive, policy, onBlocked) {
  if (typeof window === 'undefined' || !policy.blockNavigationAway) return () => {};
  const handler = () => {
    if (!examActive()) return;
    logSecurityEvent({
      type: SECURITY_EVENTS.NAVIGATION_ATTEMPT,
      severity: EVENT_SEVERITY[SECURITY_EVENTS.NAVIGATION_ATTEMPT],
      message: 'Candidate attempted browser history navigation',
      metadata: { kind: 'popstate', pathname: window.location.pathname }
    });
    if (onBlocked) onBlocked();
  };
  window.addEventListener('popstate', handler);
  return () => window.removeEventListener('popstate', handler);
}

export function shouldBlockInternalNavigation(examActive, policy, nextPath, examPathPrefix = '/') {
  if (!policy.blockNavigationAway || !examActive()) return false;
  if (nextPath == null) return true;
  const path = String(nextPath);
  if (path === examPathPrefix || path.startsWith(`${examPathPrefix}?`)) return false;
  return true;
}

export function subscribeInternalLinkGuard(logSecurityEvent, examActive, policy, examPathPrefix = '/') {
  if (typeof document === 'undefined' || !policy.blockNavigationAway) return () => {};
  const handler = (event) => {
    if (!examActive()) return;
    const anchor = event.target && event.target.closest ? event.target.closest('a') : null;
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!shouldBlockInternalNavigation(examActive, policy, url.pathname + url.search, examPathPrefix)) return;
      event.preventDefault();
      event.stopPropagation();
      logSecurityEvent({
        type: SECURITY_EVENTS.NAVIGATION_ATTEMPT,
        severity: EVENT_SEVERITY[SECURITY_EVENTS.NAVIGATION_ATTEMPT],
        message: 'Internal navigation away from the exam was blocked',
        metadata: { href, pathname: url.pathname }
      });
    } catch (_) {
      /* ignore */
    }
  };
  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
}
